/* RevTag theme — theme.js (sin dependencias) */
(function () {
  'use strict';
  var R = window.RevTag || { routes: { cartAdd: '/cart/add.js', cart: '/cart.js', cartChange: '/cart/change.js' } };

  /* Header: sombra al hacer scroll + menú móvil */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.getElementById('HeaderNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) { toggle.click(); toggle.focus(); }
    });
  }

  /* Animación del hero: solo cuando está en pantalla */
  var viz = document.querySelectorAll('.tapviz');
  if (viz.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle('is-playing', en.isIntersecting); });
    }, { threshold: 0.3 });
    viz.forEach(function (v) { io.observe(v); });
  } else { viz.forEach(function (v) { v.classList.add('is-playing'); }); }

  /* Tabs de casos de uso */
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        var n = tabs[(i + d + tabs.length) % tabs.length];
        select(n); n.focus(); e.preventDefault();
      });
    });
  });

  /* Autoenvío de orden y filtros */
  document.querySelectorAll('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form && el.form.submit(); });
  });

  /* Contador del carrito */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.hidden = n === 0;
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  }
  var toastTimer;
  function toast() {
    var t = document.getElementById('CartToast');
    if (!t) return;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 4000);
  }

  /* Añadir al carrito por AJAX (con fallback al envío normal) */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var files = form.id ? document.querySelectorAll('input[type="file"][form="' + form.id + '"]') : [];
      for (var i = 0; i < files.length; i++) { if (files[i].files && files[i].files.length) return; } /* subida de logo: envío clásico */
      var required = form.id ? document.querySelectorAll('[form="' + form.id + '"][required]') : [];
      for (var j = 0; j < required.length; j++) { if (!required[j].reportValidity()) { e.preventDefault(); return; } }
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var err = form.querySelector('[data-form-error]');
      if (btn) btn.classList.add('is-loading');
      if (err) err.hidden = true;
      fetch(R.routes.cartAdd, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function () { return fetch(R.routes.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
        .then(function (cart) { setCount(cart.item_count); toast(); })
        .catch(function (d) {
          if (err) { err.textContent = (d && (d.description || d.message)) || 'No se ha podido añadir.'; err.hidden = false; }
        })
        .finally(function () { if (btn) btn.classList.remove('is-loading'); });
    });
  });

  /* Página de producto: galería, variantes y cantidad */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var main = root.querySelector('[data-main-image]');
    root.querySelectorAll('[data-thumb]').forEach(function (th) {
      th.addEventListener('click', function () {
        if (main) { main.src = th.dataset.src; main.removeAttribute('srcset'); }
        root.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === th); });
      });
    });

    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentNode.querySelector('input');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10));
      });
    });

    var json = root.querySelector('[data-product-json]');
    var options = root.querySelector('[data-options]');
    if (!json || !options) return;
    var variants = JSON.parse(json.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');
    var priceEl = root.querySelector('.pdp__price [data-price]');
    var fmt = function (cents) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2); }
    };
    function selected() {
      var vals = [];
      options.querySelectorAll('fieldset').forEach(function (fs, i) {
        var c = fs.querySelector('input:checked');
        vals[i] = c ? c.value : null;
        var lab = fs.querySelector('[data-option-value]');
        if (lab && c) lab.textContent = c.value;
      });
      return vals;
    }
    function update() {
      var vals = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); });
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'No disponible';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? 'Añadir al carrito' : 'Agotado';
      if (priceEl) {
        priceEl.innerHTML = '<span class="price__current">' + fmt(v.price) + '</span>' + (v.compare_at_price > v.price ? '<s class="price__compare">' + fmt(v.compare_at_price) + '</s>' : '');
      }
      if (v.featured_media && main) {
        var th = root.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (th) th.click();
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    options.addEventListener('change', update);
  });

  /* Carrito: actualizar cantidades */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var f = document.getElementById('CartForm');
      if (!f) return;
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'update'; h.value = '1';
      f.appendChild(h); f.submit();
    });
  });
})();
